import { isPlainObject } from 'lodash';

// http://stackoverflow.com/questions/105034/create-guid-uuid-in-javascript

export function guid() {
  function s4() {
    return Math.floor((1 + Math.random()) * 0x10000).toString(16).substring(1);
  }

  return `${s4()}-${s4()}-${s4()}`;
}

export function bytesToSize(bytes) {
  const sizes = ['Bytes', 'KB', 'MB', 'GB', 'TB'];
  if (bytes === 0) return 'n/a';
  const i = parseInt(Math.floor(Math.log(bytes) / Math.log(1024)), 10);
  if (i === 0) return `${bytes} ${sizes[i]})`;

  return `${(bytes / 1024 ** i).toFixed(1)} ${sizes[i]}`;
}

export function flattenObject(obj, concatenator = '.') {
  return Object.keys(obj).reduce((acc, key) => {
    if (!isPlainObject(obj[key])) {
      return {
        ...acc,
        [key]: obj[key]
      };
    }

    const flattenedChild = flattenObject(obj[key], concatenator);

    return {
      ...acc,
      ...Object.keys(flattenedChild).reduce(
        (childAcc, childKey) => ({
          ...childAcc,
          [`${key}${concatenator}${childKey}`]: flattenedChild[childKey]
        }),
        {}
      )
    };
  }, {});
}



// WEBPACK FOOTER //
// ./src/client/helpers/misc.js